import { State } from "@/store/modules/system/index";
import Pusher from "pusher-js";
import { createNamespacedHelpers } from "vuex";

const getLoader = (state: State) => {
  return state.loader;
};

const getUserPaperPlaneId = (state: State) => {
  return state.userPaperPlaneId;
};
const getOpenPaperPlaneModal = (state: State) => {
  return state.openPaperPlaneModal;
};
const getOpenUserInfoModal = (state: State) => {
  return state.openUserInfoModal;
};

const getUserInfoId = (state: State) => {
  return state.userInfoId;
};

const getWonderPointUrl = (state: State) => {
  return state.wonderPointUrl;
};

const getOpenWonderPointModal = (state: State) => {
  return state.openWonderPointModal;
};

const getDeviceNotification = (state: State) => {
  return state.deviceNotification;
};

const getOpenChangeSpaceModal = (state: State): boolean => {
  return state.openChangeSpaceModal;
};

const getShowUserTechnicalInfo = (state: State): boolean | null => {
  return state.showUserTechnicalInfo;
};

const getPusher = (state: State): Pusher => {
  return state.pusher;
};

const getSpaceUserTechnicalInfoReceived = (state: State): any => {
  return state.spaceUserTechnicalInfoReceived;
};

const getGraphicClientVersion = (state: State): any => {
  return state.graphicClientVersion;
};

const getShowWelcome = (state: State): boolean => {
  return state.showWelcome;
};

const getShowCompleteOnBoarding = (state: State): boolean => {
  return state.showCompleteOnBoarding;
};

const getSuggestionsNotifications = (state: State): boolean => {
  return state.suggestionsNotifications;
};

const getMaintenanceModal = (state: State): boolean => {
  return state.maintenanceModal;
};

const getMaintenanceStart = (state: State): number => {
  return state.maintenanceStart;
};

const getMaintenaceFinish = (state: State): number => {
  return state.maintenaceFinish;
};

const getMaintenanceMessageError = (state: State): boolean => {
  return state.maintenanceMessageError;
};

const getShowPhotonErrorModal = (state: State): boolean => {
  return state.showPhotonErrorModal;
};

const getExitModal = (state: State): boolean => {
  return state.showExitModal;
};

const getZoom = (state: State): number => {
  return state.zoom;
};

const getMaxZoom = (state: State): number => {
  return state.maxZoom;
};

const getMinZoom = (state: State): number => {
  return state.minZoom;
};

const getShowCameraOptions = (state: State): boolean => {
  return state.showCameraOptions;
};

const getTutorialModal = (state: State): boolean => {
  return state.showTutorialModal;
};

const getTutorialText = (state: State): number => {
  return state.tutorialText;
};

const getCallTimer = (state: State): any => {
  return state.callTimer;
};

const getTutorialNotification = (state: State): any => {
  return state.notificationTutorial;
};

const getManageSpaceMenuActive = (state: State): string => {
  return state.manageSpaceMenuActive;
};

const getConfirmBanModal = (state: State): any => {
  return state.showConfirmBanModal;
};

const getConfirmBanModalData = (state: State): any => {
  return state.confirmModalData;
};

const getDescriptionBoothModal = (state: State): boolean => {
  return state.showDescriptionBooth;
};

const getDescriptionBoothModalData = (state: State): any => {
  return state.dataDescriptionBooth;
};

const getDescriptionBoothTimeOut = (state: State): any => {
  return state.descriptionBoothTimeOut;
};

const getDescriptionBoothCountDown = (state: State): boolean => {
  return state.descriptionBoothCountDown;
};

const getVacationModal = (state: State): boolean => {
  return state.showVacation;
};

const getShowGoodMorningModal = (state: State): boolean => {
  return state.showGoodMorningModal;
};

const getBlockChangeEmoji = (state: State): boolean => {
  return state.blockChangeEmoji;
};

const getReactions = (state: State): any => {
  return state.reactions;
};

const getShowWebGLContextLostModal = (state: State): boolean => {
  return state.showWebGLContextLostModal;
};

const getShowCloseWebinarModal = (state: State): boolean => {
  return state.showCloseWebinarModal;
};

const getWebinarCloseId = (state: State): number => {
  return state.webinarCloseId;
};

const getShowCallErrorModal = (state: State): boolean => {
  return state.showCallErrorModal;
};

const getSelecSuperSpaceId = (state: State): number => {
  return state.selecSuperSpaceId;
};

const getSelectedPinSuperSpaceId = (state: State): number => {
  return state.selectedPinSuperSpaceId;
};

const getPinCountDown = (state: State): boolean => {
  return state.pinCountDown;
};

const getShowPinModal = (state: State): boolean => {
  return state.showPinModal;
};

const getPinTimeOut = (state: State): any => {
  return state.pinTimeOut;
};

const getSuperSpaceUserPaperPlaneId = (state: State) => {
  return state.superSpaceUserPaperPlaneId;
};

const getShowPinRoomModal = (state: State) => {
  return state.showPinRoomModal;
};

const getIsChangePin = (state: State) => {
  return state.isChangePin;
};

const getManageModalType = (state: State) => {
  return state.manageModalType;
};

const getPoster = (state: State) => {
  return state.poster;
};

const getOpenPosterModal = (state: State) => {
  return state.openPosterModal;
};

const getErrorGeneralClientGraphic = (state: State): boolean => {
  return state.errorGeneralClientGraphic;
};

const getErrorDataGeneralClientGraphic = (state: State): string => {
  return state.errorDataGeneralClientGraphic;
};

const getShowCallErrorRetryModal = (state: State): boolean => {
  return state.showCallErrorRetryModal;
};

const getShowBirthdayModal = (state: State): boolean => {
  return state.showBirthdayModal;
};

const getDataBirthdayModal = (state: State): any => {
  return state.dataBirthdayModal;
};

const getOpenChangeSpaceFavouriteModal = (state: State): boolean => {
  return state.openChangeSpaceFavouriteModal;
};

const getOpenNotepadButton = (state: State): boolean => {
  return state.openNotepadButton;
};

const getOpenNotepadModal = (state: State): boolean => {
  return state.openNotepadModal;
};

const getCurrentRoom = (state: State): any => {
  return state.currentRoom;
};

const getShowCompleteOnBoardingTeams = (state: State): boolean => {
  return state.showCompleteOnBoardingTeams;
};

const getWaitingResponseTimeout = (state: State): any => {
  return state.waitingResponseTimeout;
};

const getShowRobotModal = (state: State): boolean => {
  return state.showRobotModal;
};

const getShowEducationModal = (state: State): boolean => {
  return state.showEducationModal;
};

const getShowEducationToolModal = (state: State): boolean => {
  return state.showEducationToolModal;
};

const getEducationBotId = (state: State): number => {
  return state.educationBotId;
};

const getOpenSpotifyModal = (state: State): boolean => {
  return state.openSpotifyModal;
};

const getGameKillerModal = (state: State): boolean => {
  return state.showGameKillerModal;
};

const getGameKillerInfoModal = (state: State): boolean => {
  return state.showGameKillerInfoModal;
};

const getGameKillerVoteAndWinnerModal = (state: State): boolean => {
  return state.showGameKillerVoteAndWinnerModal;
};

const getGameKillerWinner = (state: State): boolean => {
  return state.gamekillerWinner;
};

const getReserveRoomModal = (state: State): boolean => {
  return state.reserveRoomModal;
};

const getCttiGameModal = (state: State): boolean => {
  return state.showCttiGameModal;
};

const getAutoVideoEnterModal = (state: State): boolean => {
  return state.showAutoVideoEnterModal;
};

const getAutoVideo = (state: State): boolean => {
  return state.autoVideo;
};

const getReservePhysicalRoomModal = (state: State): boolean => {
  return state.reservePhysicalRoomModal;
};

const getAssistant = (state: State): any => {
  return state.assistant;
};

const getAccessTokenGoogle = (state: State): any => {
  return state.accessTokenGoogle;
};

const getAccessTokenHotmail = (state: State): any => {
  return state.accessTokenHotmail;
};

const getShowModalPlanWarningPremium = (state: State): any => {
  return state.showModalPlanWarningPremium;
};

export default {
  getLoader,
  getUserPaperPlaneId,
  getOpenPaperPlaneModal,
  getOpenUserInfoModal,
  getUserInfoId,
  getWonderPointUrl,
  getOpenWonderPointModal,
  getDeviceNotification,
  getOpenChangeSpaceModal,
  getShowUserTechnicalInfo,
  getPusher,
  getSpaceUserTechnicalInfoReceived,
  getGraphicClientVersion,
  getShowWelcome,
  getShowCompleteOnBoarding,
  getSuggestionsNotifications,
  getMaintenanceModal,
  getMaintenanceStart,
  getMaintenaceFinish,
  getMaintenanceMessageError,
  getShowPhotonErrorModal,
  getExitModal,
  getZoom,
  getMaxZoom,
  getMinZoom,
  getShowCameraOptions,
  getTutorialModal,
  getTutorialText,
  getCallTimer,
  getTutorialNotification,
  getManageSpaceMenuActive,
  getConfirmBanModal,
  getConfirmBanModalData,
  getDescriptionBoothModal,
  getDescriptionBoothModalData,
  getVacationModal,
  getShowGoodMorningModal,
  getBlockChangeEmoji,
  getReactions,
  getDescriptionBoothTimeOut,
  getShowWebGLContextLostModal,
  getShowCloseWebinarModal,
  getWebinarCloseId,
  getDescriptionBoothCountDown,
  getShowCallErrorModal,
  getSelecSuperSpaceId,
  getSelectedPinSuperSpaceId,
  getPinCountDown,
  getShowPinModal,
  getPinTimeOut,
  getSuperSpaceUserPaperPlaneId,
  getShowPinRoomModal,
  getIsChangePin,
  getManageModalType,
  getPoster,
  getOpenPosterModal,
  getErrorGeneralClientGraphic,
  getErrorDataGeneralClientGraphic,
  getShowCallErrorRetryModal,
  getShowBirthdayModal,
  getDataBirthdayModal,
  getOpenChangeSpaceFavouriteModal,
  getOpenNotepadButton,
  getOpenNotepadModal,
  getCurrentRoom,
  getShowCompleteOnBoardingTeams,
  getWaitingResponseTimeout,
  getShowRobotModal,
  getShowEducationModal,
  getShowEducationToolModal,
  getEducationBotId,
  getOpenSpotifyModal,
  getGameKillerModal,
  getGameKillerInfoModal,
  getGameKillerVoteAndWinnerModal,
  getGameKillerWinner,
  getReserveRoomModal,
  getCttiGameModal,
  getAutoVideoEnterModal,
  getAutoVideo,
  getReservePhysicalRoomModal,
  getAssistant,
  getAccessTokenGoogle,
  getAccessTokenHotmail,
  getShowModalPlanWarningPremium,
};
